import { Typography } from "@material-ui/core";
import _img from "./../../../assets/image_calc.png";

const SelectionMessage = () => {
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        alignContent: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography variant="h5" color="primary" align="center">
          Visualizar Cotizaciones
        </Typography>
        <div>
          <img alt="sss" src={_img} height={300} />
        </div>
        <Typography variant="body1" color="textSecondary" align="center">
          Seleccione los filtros para visualizar los resultados
        </Typography>
        <br />
      </div>
    </div>
  );
};

export default SelectionMessage;
